export default __webpack_public_path__ + "static/media/btn-gnb-popup-close.5cca16a7.svg";